export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_CLIENT_URL: import.meta.env.VITE_CLIENT_URL,
  VITE_FEATURE_HOUSEHOLD_REDIRECT: import.meta.env
    .VITE_FEATURE_HOUSEHOLD_REDIRECT,
  VITE_API_CLIENT_URL: import.meta.env.VITE_API_CLIENT_URL,
  VITE_OPERATIONAL_ACCOUNTING_API_URL: import.meta.env
    .VITE_OPERATIONAL_ACCOUNTING_API_URL,
  VITE_ACTUAL_ACCOUNTING_API_URL: import.meta.env
    .VITE_ACTUAL_ACCOUNTING_API_URL,
  VITE_CRM_URL: import.meta.env.VITE_CRM_URL,
  VITE_DISTRIBUTION_ADMIN_URL: import.meta.env.VITE_DISTRIBUTION_ADMIN_URL,
};
